//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { handleInvokeMainbook, handleRevokeMainbook , handleInvokeEbookGalleryView , handleRevokeEbookGalleryView, handleSentenceRevoke, handleSentenceInvoke, handleInvokeAnswer, handleRevokeAnswer, handleAiAnswerInvoke, handleAiAnswerRevoke, handleRevokeStory, handleInvokeStory, handleMatchMakingInvoke, handleMatchMakingRevoke, handleInvokePDF, handleRevokePDF, handleInvokeActivityStandards, handleRevokeActivityStandards} from './thunks';


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.mainbookPageView;

//  -- Examples array selector --------

export const useMainbookView = () => {
    const selectedData = useSelector(selector, shallowEqual)
    const dispatch = useDispatch()
    const invokeMainbookView = (pages) => {
        dispatch(handleInvokeMainbook(true, pages))
    }
    const revokeMainbookView = () => {
        dispatch(handleRevokeMainbook())
    }
    return {
        mainbookPageView: selectedData,
        invokeMainbookView,
        revokeMainbookView
    };
}

const galleryselector = (state) => state.ebookGalleryView;
export const useEbookGalleryView = () => {
    const selectedData = useSelector(galleryselector, shallowEqual)
    const dispatch = useDispatch()
    const invokeEbookGalleryView = (pages) => {
        dispatch(handleInvokeEbookGalleryView(true, pages))
    }
    const revokeEbookGalleryView = () => {
        dispatch(handleRevokeEbookGalleryView())
    }
    return {
        ebookGalleryView: selectedData,
        invokeEbookGalleryView,
        revokeEbookGalleryView
    };
}

const sentenceSelector = (state) => state.sentenceView;

//  -- Examples array selector --------

export const useSentenceView = () => {
    const selectedData = useSelector(sentenceSelector, shallowEqual)
    const dispatch = useDispatch()
    const invokeSentenceView = (pages) => {
        dispatch(handleSentenceInvoke(true, pages))
    }
    const revokeSentenceView = () => {
        dispatch(handleSentenceRevoke())
    }
    return {
        sentenceView: selectedData,
        invokeSentenceView,
        revokeSentenceView
    };
}

// Answer

const answerSelector = (state) => state.answerView;

//  -- Examples array selector --------

export const useAnswerView = () => {
    const selectedData = useSelector(answerSelector, shallowEqual)
    const dispatch = useDispatch()
    const invokeAnswerView = (pages,type) => {
        dispatch(handleInvokeAnswer(true, pages,type))
    }
    const revokeAnswerView = () => {
        dispatch(handleRevokeAnswer())
    }
    return {
        answerView: selectedData,
        invokeAnswerView,
        revokeAnswerView
    };
}

const aiAnswerSelector = (state) => state.aiAnswerView;

//  -- Examples array selector --------

export const useAiAnswerView = () => {
    const selectedData = useSelector(aiAnswerSelector, shallowEqual)
    const dispatch = useDispatch()
    const invokeAiAnswerView = (questions) => {
        dispatch(handleAiAnswerInvoke(true, questions))
    }
    const revokeAiAnswerView = () => {
        dispatch(handleAiAnswerRevoke())
    }
    return {
        aiAnswerView: selectedData,
        invokeAiAnswerView,
        revokeAiAnswerView
    };
}

const matchMakingSelector = (state) => state.matchMakingView;

// Match Making
export const useMatchMakingView = () => {
    const selectedData = useSelector(matchMakingSelector, shallowEqual)
    const dispatch = useDispatch()
    const matchMakingFullScreenOpen  = () => {
        dispatch(handleMatchMakingInvoke(true))
    }
    const revokeMatchMakingFullScreenClose = () => {
        dispatch(handleMatchMakingRevoke(false))
    }
    return {
        matchMakingView: selectedData,
        matchMakingFullScreenOpen,
        revokeMatchMakingFullScreenClose
    };
}


// Story

const storySelector = (state) => state.storyView;

//  -- Examples array selector --------

export const useStoryView = () => {
    const selectedData = useSelector(storySelector, shallowEqual)
    const dispatch = useDispatch()
    const invokeStoryView = (pages,type) => {
        dispatch(handleInvokeStory(true, pages,type))
    }
    const revokeStoryView = () => {
        dispatch(handleRevokeStory())
    }
    return {
        storyView: selectedData,
        invokeStoryView,
        revokeStoryView
    };
}

const pdfSelector = (state) => state.pdfView;

export const usePDFView = () => {
    const selectedData = useSelector(pdfSelector, shallowEqual)
    const dispatch = useDispatch()
    const invokePDFView = (pdf) => {
        dispatch(handleInvokePDF(true, pdf))
    }
    const revokePDFView = () => {
        dispatch(handleRevokePDF())
    }
    return {
        pdfView: selectedData,
        invokePDFView,
        revokePDFView
    };
}

const activityStandardsSelector = (state) => state.activityStandardsView;

export const useActivityStandardsView = () => {
    const selectedData = useSelector(activityStandardsSelector, shallowEqual)
    const dispatch = useDispatch()
    const invokeActivityStandardsView = (activities, standards, enabledStateCodes, bookData, units, pages, currentPage) => {
        dispatch(handleInvokeActivityStandards(true, activities, standards, enabledStateCodes, bookData, units, pages, currentPage))
    }
    const revokeActivityStandardsView = () => {
        dispatch(handleRevokeActivityStandards())
    }
    return {
        activityStandardsView: selectedData,
        invokeActivityStandardsView,
        revokeActivityStandardsView
    };
}